function initMarquees() {
  if (typeof gsap === "undefined") return;

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  document.querySelectorAll("[data-marquee], .marquee").forEach((root) => {
    if (root.dataset.marqueeBound === "1") return;

    const track = root.querySelector(".marquee__track");
    const source = root.querySelector(".marquee__group");
    if (!track || !source) return;

    root.dataset.marqueeBound = "1";

    let tween = null;
    let wrapWidth = 0;
    let resizeTimer = 0;
    let isVisible = false;
    let isHovered = false;
    let lastRootWidth = 0;

    const clearClones = () => {
      track.querySelectorAll("[data-marquee-clone]").forEach((clone) => {
        clone.remove();
      });
    };

    const cycleWidth = () => {
      const groupBox = source.getBoundingClientRect();
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return groupBox.width + gap;
    };

    const fillTrack = () => {
      clearClones();
      gsap.set(track, { x: 0 });

      const cycle = cycleWidth();
      if (cycle < 1) return 0;

      const copies = Math.max(1, Math.ceil(root.offsetWidth / cycle) + 1);
      for (let i = 0; i < copies; i++) {
        const clone = source.cloneNode(true);
        clone.setAttribute("data-marquee-clone", "1");
        clone.setAttribute("aria-hidden", "true");
        track.appendChild(clone);
      }

      return cycle;
    };

    const killTween = () => {
      if (!tween) return;
      tween.kill();
      tween = null;
    };

    const play = () => {
      if (reduceMotion.matches) {
        reset();
        return;
      }

      wrapWidth = fillTrack();
      if (wrapWidth < 1) return;
      lastRootWidth = root.offsetWidth;

      killTween();

      const speed = Number(root.dataset.marqueeSpeed) || 80;
      const wrapX = gsap.utils.wrap(-wrapWidth, 0);

      gsap.set(track, { x: 0 });
      tween = gsap.to(track, {
        x: -wrapWidth,
        duration: wrapWidth / speed,
        ease: "none",
        repeat: -1,
        modifiers: {
          x: (value) => wrapX(parseFloat(value)) + "px",
        },
      });

      if (isHovered) tween.pause();
    };

    const reset = () => {
      killTween();
      gsap.set(track, { x: 0 });
    };

    const syncVisibility = (visible) => {
      isVisible = visible;
      if (visible) {
        play();
        return;
      }
      reset();
    };

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target !== root) return;
          syncVisibility(entry.isIntersecting);
        });
      },
      { threshold: 0, rootMargin: "0px" }
    );

    io.observe(root);

    const rebuildIfVisible = () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        if (!isVisible) return;
        const nextWidth = root.offsetWidth;
        if (Math.abs(nextWidth - lastRootWidth) < 1 && tween) return;
        lastRootWidth = nextWidth;
        play();
      }, 150);
    };

    root.addEventListener("mouseenter", () => {
      isHovered = true;
      if (tween) tween.pause();
    });

    root.addEventListener("mouseleave", () => {
      isHovered = false;
      if (tween && isVisible && !reduceMotion.matches) tween.play();
    });

    window.addEventListener("resize", rebuildIfVisible);

    if (typeof ResizeObserver === "function") {
      const ro = new ResizeObserver(rebuildIfVisible);
      ro.observe(root);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        if (isVisible) play();
      });
    }

    root.querySelectorAll("img").forEach((img) => {
      if (img.complete) return;
      img.addEventListener(
        "load",
        () => {
          if (isVisible) play();
        },
        { once: true }
      );
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initMarquees();
});

document.addEventListener("DOMContentLoaded", () => {
  const observerOptions = {
    threshold: 0.08,
    rootMargin: "-80px 0px -50px 0px",
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const el = entry.target;

      if (entry.isIntersecting) {
        el.classList.add("is-visible");
        el.classList.add("has-been-seen");
      } else {
        if (el.classList.contains("has-been-seen")) {
          el.classList.remove("is-visible");
        }
      }
    });
  }, observerOptions);

  // Single elements
  document.querySelectorAll("[data-animate]").forEach((el) => {
    observer.observe(el);
  });

  // Stagger groups
  document.querySelectorAll("[data-animate-group]").forEach((group) => {
    [...group.children].forEach((child) => {
      if (!child.hasAttribute("data-animate")) {
        child.setAttribute("data-animate", "fade-up");
      }
      observer.observe(child);
    });
  });
});
